import AudioPlayer from "./AudioPlayer";
import ShareButton from "@/components/ShareButton";
import Thumbnail from "@/components/Thumbnails";
import CheckOutWrapper from "@/components/stripe/CheckOutWrapper";
import { cardStore } from "@/stores/nowPlayingStore";
import {
  Center,
  Container,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";
import { useStore } from "@tanstack/react-store";
import { AiOutlineShopping } from "react-icons/ai";

function PlayerBar() {
  const { colorMode } = useColorMode();
  const card = useStore(cardStore, (state) => state);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const backgroundColor = colorMode === "light" ? "white" : "black";

  return (
    <div
      id="songcards-player-bar"
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        ...(colorMode === "light"
          ? {
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }
          : {
              backgroundColor: "black",
            }),
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Container maxW={900} maxH={40}>
        <Grid
          templateColumns="repeat(3, 1fr)"
          gap={6}
          alignItems="center"
          justifyContent="center"
          ml={10}
          mr={10}
        >
          <Center>
            {card.card.title && (
              <AiOutlineShopping
                cursor={"pointer"}
                onClick={onOpen}
                size={24}
              />
            )}
          </Center>
          <AudioPlayer
            file={card.card.song.ext_file ?? card.card.song.file ?? ""}
            uuid={card.card.uuid}
            title={card.card.title}
            onOpen={onOpen}
          />
          <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom">
            <ModalOverlay
              backdropInvert="80%"
              backdropFilter="blur(10px) hue-rotate(10deg)"
            />

            <ModalContent
              backgroundColor={backgroundColor}
              maxW={300}
              borderRadius={20}
            >
              <Text ml={6} mt={4}>
                You are previewing...
              </Text>
              <ModalHeader mt={-2} mb={-3}>
                {card.card.title}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Thumbnail
                  ext_file={card.card.ext_file}
                  comp_file={card.card.comp_file}
                  image={card.card.image}
                />
                <CheckOutWrapper
                  price={2.99}
                  art={""}
                  uuid={card.card.uuid}
                  image={card.card.comp_file ?? card.card.ext_file ?? ""}
                  id={card.card.id}
                  issued={""}
                  ext_file={card.card.ext_file ?? ""}
                />
              </ModalBody>
            </ModalContent>
          </Modal>
          <Center>
            {card.card.title && <ShareButton uuid={card.card.uuid} />}
          </Center>
        </Grid>
      </Container>
    </div>
  );
}

export default PlayerBar;
